import { useTranslation } from 'react-i18next';

import WorkspaceHierarchySection from './WorkspaceHierarchySection';

const SubWorkspacesTab = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col space-y-4">
      <span className="text-xl font-semibold">{t('workspaces.sub_workspaces')}</span>
      <WorkspaceHierarchySection />
    </div>
  );
};

export default SubWorkspacesTab;
